import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { cn } from '@/lib/cn';
import type { WorkspaceStage } from './bulk-import-ui.constants';

const STEPS: { key: WorkspaceStage; label: string }[] = [
  { key: 'setup', label: 'Setup' },
  { key: 'upload', label: 'Upload' },
  { key: 'processing', label: 'Processing' },
  { key: 'review', label: 'Review & Correct' },
  { key: 'final', label: 'Final Import' },
];

const ORDER: WorkspaceStage[] = ['setup', 'upload', 'processing', 'review', 'final'];

interface BulkImportStepperProps {
  current: WorkspaceStage;
}

export function BulkImportStepper({ current }: BulkImportStepperProps) {
  const currentIndex = ORDER.indexOf(current);

  return (
    <ol className="flex flex-wrap items-center gap-x-1 gap-y-3" aria-label="Bulk import progress">
      {STEPS.map((step, i) => {
        const isDone = i < currentIndex;
        const isCurrent = i === currentIndex;
        return (
          <li key={step.key} className="flex items-center gap-1">
            <div
              className={cn(
                'flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-medium',
                isCurrent && 'bg-primary text-primary-foreground',
                isDone && 'bg-green-500/10 text-green-700',
                !isCurrent && !isDone && 'bg-muted text-muted-foreground',
              )}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <span
                className={cn(
                  'flex h-4 w-4 items-center justify-center rounded-full text-[10px]',
                  isCurrent && 'bg-primary-foreground/20',
                  isDone && 'bg-green-600 text-white',
                  !isCurrent && !isDone && 'bg-border',
                )}
              >
                {isDone ? <FontAwesomeIcon icon={faCheck} className="h-2.5 w-2.5" /> : i + 1}
              </span>
              {step.label}
            </div>
            {i < STEPS.length - 1 && <span className="h-px w-4 bg-border" aria-hidden="true" />}
          </li>
        );
      })}
    </ol>
  );
}
